module.exports = __webpack_public_path__ + "static/img/expr_img.d58b21ca.png";